import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWebResearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 27,
	height: 27,
	viewBox: "0 0 27 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5 26C16.2708 25.9998 18.9631 25.0795 21.1542 23.3834C23.3453 21.6873 24.911 19.3115 25.6055 16.6292M13.5 26C10.7292 25.9998 8.03686 25.0795 5.8458 23.3834C3.65473 21.6873 2.089 19.3115 1.39445 16.6292M13.5 26C16.9514 26 19.75 20.4028 19.75 13.5C19.75 6.59722 16.9514 1 13.5 1M13.5 26C10.0486 26 7.25 20.4028 7.25 13.5C7.25 6.59722 10.0486 1 13.5 1M25.6055 16.6292C25.8625 15.6292 26 14.5806 26 13.5C26.0034 11.3502 25.4498 9.2361 24.393 7.36389M25.6055 16.6292C21.9016 18.6825 17.735 19.7566 13.5 19.75C9.10833 19.75 4.98195 18.6181 1.39445 16.6292M1.39445 16.6292C1.1316 15.6069 0.999066 14.5555 1 13.5C1 11.2708 1.58334 9.17639 2.60695 7.36389M13.5 1C15.717 0.999076 17.8943 1.588 19.8086 2.70634C21.7229 3.82468 23.3051 5.43218 24.393 7.36389M13.5 1C11.283 0.999076 9.10566 1.588 7.1914 2.70634C5.27714 3.82468 3.69487 5.43218 2.60695 7.36389M24.393 7.36389C21.369 9.98323 17.5007 11.4224 13.5 11.4167C9.33611 11.4167 5.52778 9.88889 2.60695 7.36389",
		stroke: "#454CFC",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgWebResearch;
